import qs from 'query-string';

const SESSION_PLAN_ID_KEY = 'Skinny-sign-up-plan-id';
const SESSION_UUID_KEY = 'Skinny-sign-up-uuid';
const getPlanIdFromQueryString = (props) => {
  const { location } = props;
  const queryParams = qs.parse(location.search || '');
  return queryParams.planId;
};

const checkTestDiscountStatus = () => {
  const queryParams = qs.parse(window.location.search || '');
  return queryParams.withDiscount === 'true';
};

const getUUIdFromQueryString = (props) => {
  const { location } = props;
  const queryParams = qs.parse(location.search || '');
  return queryParams.id;
};

const getPlanIdFromSession = () => {
  if (window.sessionStorage) {
    return window.sessionStorage.getItem(SESSION_PLAN_ID_KEY);
  }
  return null;
};

const getUUIdFromSession = () => {
  if (window.sessionStorage) {
    return window.sessionStorage.getItem(SESSION_UUID_KEY);
  }
  return null;
};

const setUUIdToSession = (uuid) => {
  if (window.sessionStorage) {
    window.sessionStorage.setItem(SESSION_UUID_KEY, uuid);
  }
};

const setPlanIdToSession = (planId) => {
  if (window.sessionStorage) {
    window.sessionStorage.setItem(SESSION_PLAN_ID_KEY, planId);
  }
};
const getPlanPrice = (price, discounts) => (
   [price, ...discounts].reduce((total, discount) => total + discount)
);

export default {
  getPlanIdFromQueryString,
  getPlanIdFromSession,
  setPlanIdToSession,
  checkTestDiscountStatus,
  getPlanPrice,
  setUUIdToSession,
  getUUIdFromSession,
  getUUIdFromQueryString
};



/** WEBPACK FOOTER **
 ** ./src/common/PlanIdUtil.js
 **/